import React from 'react';
import PropTypes from 'prop-types';
import {Wrapper} from './Wrapper';
import {ContentWrap} from './ContentWrap';
import {RemoveOption} from './RemoveOption';
import {GlossaryOption} from './GlossaryOption';
import {Options} from './Options';
import {GlossaryProvider} from '@learningblocks/storybook-components';
import {MoveOption} from './MoveOption';
import {RenderHTML, Image} from '@learningblocks/shared-components';
import {Description} from './Description';

import cn from './style.module.scss';

/**
 * RectangleNode
 *  -
 *
 */

const COLOUR_NORMAL = '#f7f7f7';
const COLOR_HOVER = '#E5ECF0';

export function RectangleCard(props) {
  const {onOpenGlossary} = React.useContext(GlossaryProvider.Context);

  const [backgroundColor, setColor] = React.useState(COLOUR_NORMAL);

  //for detecting hover
  const onMouseLeave = () => {
    setColor(COLOUR_NORMAL);
  };
  const onMouseEnter = () => {
    setColor(COLOR_HOVER);
  };

  const hoverStyle = () => ({backgroundColor: backgroundColor});

  const searchGlossary = () => {
    onOpenGlossary(props.glossaryId)
  };

  let className = `${cn.rectangle} ${props.hasShadow ? cn.shadow : ''} ${
    !props.addCard ? cn.cursorPointer : ''
  } ${props.className}`;

  const onClickIfNotOption = () => {
    if (!props.isMobileOption && !props.addCard) searchGlossary();
  };

  return (
    <Wrapper
      className={className}
      tabIndex={props.tabIndex}
      onClick={onClickIfNotOption}>
      <Image
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        style={hoverStyle()}
        className={`${cn.rectangle_image}`}
        src={props.image}
        alt=""
      />
      <ContentWrap
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        style={hoverStyle()}
        className={`${cn.rectangle_content}`}>
        <RenderHTML content={props.title} />
        <Description description={props.description} trim={props.trim} />
      </ContentWrap>
      <Options className={`${cn.rectangle_option}`}>
        <GlossaryOption
          className={cn.rectangle_option_iconWrap}
          onKeyDown={props.openGlossary}
          onClick={searchGlossary}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
          isOption={props.addCard}
          style={{backgroundColor: backgroundColor}}
          tabIndex={props.tabIndex}
          title={props.title}
        />
        <RemoveOption
          className={cn.rectangle_option_iconWrap}
          onSelect={props.removeCard}
          tabIndex={props.tabIndex}
        />
        <MoveOption
          className={cn.rectangle_option_iconWrap}
          onSelect={props.addCard}
          tabIndex={props.tabIndex}
        />
      </Options>
    </Wrapper>
  );
}

RectangleCard.propTypes = {
  /**
   * tabIndex to set on component
   */
  tabIndex: PropTypes.number,
  /**
   * ClassName to set on component
   */
  className: PropTypes.string,
  /**
   * callback function to be executed when card is added as next step in DesignSection
   * Prop should be null if addCard icon not required
   */
  addCard: PropTypes.func,
  /**
   * callback function to be executed when card needs to be removed from design section tree
   * Prop should be null if removeCard icon not required
   */
  removeCard: PropTypes.func,
  /**
   * Callback function to be executed when info icon in the card is clicked or selected
   * the callback use the title of card to invoke a search operation in glossary
   */
  openGlossary: PropTypes.func,
  /**
   * Url to the small card icon image
   */
  image: PropTypes.string.isRequired,
  /**
   * Title of the card
   */
  title: PropTypes.string.isRequired,
  /**
   * display shadow box
   */
  hasShadow: PropTypes.bool,
  /**
   * description for rectangle card
   */
  description: PropTypes.string,
  /**
   * spcifies if it is used as option in mob/tab
   */
  isMobileOption: PropTypes.bool,
  /**
   * Trim is a boolean used to ditermine wheather the description should trim or not
   */
  trim: PropTypes.bool,
};

RectangleCard.defaultProps = {
  tabIndex: 0,
  removeCard: undefined,
  hasShadow: true,
  isMobileOption: false,
  trim: true,
};
